import React from 'react';

function BlogList({ blogs, pillarBlogId, setPillarBlogId, onPostClick }) {
  return (
    <div className="max-w-4xl mx-auto mb-6">
      <h2 className="text-xl font-semibold mb-4">Blogs in this Category ({blogs.length})</h2>
      <ul className="space-y-3">
        {blogs.map((blog) => (
          <li
            key={blog.id}
            className={`p-4 border rounded cursor-pointer flex justify-between items-center ${
              pillarBlogId === blog.id ? 'bg-blue-100 border-blue-500' : 'bg-white border-gray-300'
            }`}
            onClick={() => onPostClick ? onPostClick(blog) : setPillarBlogId(blog.id)}
            title="Click to mark as pillar content or view details"
          >
            <div>
              <p className="font-medium">{blog.title}</p>
              <p className="text-sm text-gray-600">{blog.url}</p>
              <p className="text-xs text-gray-500">Word count: {blog.wordCount}</p>
            </div>
            {pillarBlogId === blog.id && (
              <span className="text-blue-600 font-bold">Pillar</span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default BlogList;
